import { CatalogueDataType } from './catalogue'
import { FlowErrorType } from './error'

export enum CartConditionOptions {
  NO_CONDITIONS = 'NO_CONDITIONS',
  PURCHASE_AMOUNT = 'PURCHASE_AMOUNT',
  PURCHASE_QUANTITY = 'PURCHASE_QUANTITY'
}

export enum PurchaseOptions {
  ENTIRE_CART = 'ENTIRE_CART',
  SPECIFIC_PRODUCTS = 'SPECIFIC_PRODUCTS',
  SPECIFIC_COLLECTIONS = 'SPECIFIC_COLLECTIONS'
}

export type QuantityDistributorBlockType = {
  minimumValue: number | ''
  maximumEnabled: boolean
  maximumValue: number | ''
  applicationType: CartConditionOptions.PURCHASE_AMOUNT | CartConditionOptions.PURCHASE_QUANTITY
  catalogueMetadata: CatalogueDataType[]
}

export type ProductQuantityDistributorBlockType = QuantityDistributorBlockType & {
  catalogType: PurchaseOptions.SPECIFIC_PRODUCTS
  productIds: string[]
  variantIds: string[]
}

export type CollectionQuantityDistributorBlockType = QuantityDistributorBlockType & {
  catalogType: PurchaseOptions.SPECIFIC_COLLECTIONS
  collectionIds: string[]
}

export type QuantityDistributorType =
  | {
      type: PurchaseOptions.SPECIFIC_PRODUCTS
      quantityDistributionItems: ProductQuantityDistributorBlockType[]
    }
  | {
      type: PurchaseOptions.SPECIFIC_COLLECTIONS
      quantityDistributionItems: CollectionQuantityDistributorBlockType[]
    }

export type CartConditionStateType =
  | {
      type: CartConditionOptions.NO_CONDITIONS
    }
  | {
      type: CartConditionOptions.PURCHASE_AMOUNT | CartConditionOptions.PURCHASE_QUANTITY
      selectedOption:
        | {
            type: PurchaseOptions.ENTIRE_CART
            minimumValue: number | ""
            maximumEnabled: boolean
            maximumValue: number | ""
          }
        | {
            type: PurchaseOptions.SPECIFIC_PRODUCTS
            quantityDistribution: QuantityDistributorType
          }
        | {
            type: PurchaseOptions.SPECIFIC_COLLECTIONS
            quantityDistribution: QuantityDistributorType
          }
    }

export type CartConditionErrorStateType =
  | {
      type: PurchaseOptions.ENTIRE_CART
      minimumValue: FlowErrorType
      maximumValue: FlowErrorType
    }
  | {
      type: PurchaseOptions.SPECIFIC_PRODUCTS | PurchaseOptions.SPECIFIC_COLLECTIONS
      quantityDistribution: QuantityDistributorErrorStateType[]
    }

export type QuantityDistributorErrorStateType = {
  minimumValue: FlowErrorType
  maximumValue: FlowErrorType
  selectedItems: FlowErrorType
}
